"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BasesV3Service", {
    enumerable: true,
    get: function() {
        return BasesV3Service;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _basemetaprops = require("~/types/metaProps/base-meta-props");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _basesservice = require("~/services/bases.service");
const _globals = require("~/utils/globals");
const _helpers = require("~/helpers");
const _base = require("~/utils/builders/base");
const _basememberhelpers = require("~/services/v3/members/base-member-helpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let BasesV3Service = class BasesV3Service {
    async getBaseList(context, param) {
        var _param_user;
        return (0, _nocodbsdk.extractRolesObj)((_param_user = param.user) == null ? void 0 : _param_user.roles)[_nocodbsdk.OrgUserRoles.SUPER_ADMIN] ? await _models.Base.list() : await _models.BaseUser.getProjectsList(param.user.id, param.query);
    }
    async baseList(context, param) {
        const bases = await this.getBaseList(context, param);
        const formattedBases = [];
        for (const base of bases){
            const sources = (0, _base.sourceBuilder)().build((await new _models.Base(base).getSources()).filter((s)=>!new _models.Source(s).isMeta()));
            formattedBases.push(_extends({}, (0, _base.baseBuilder)().build(base), {
                sources: sources.length ? sources : undefined
            }));
        }
        return formattedBases;
    }
    async getProject(context, param) {
        const base = await _models.Base.get(context, param.baseId);
        const sources = (0, _base.sourceBuilder)().build((await new _models.Base(base).getSources()).filter((s)=>!new _models.Source(s).isMeta()));
        return _extends({}, (0, _base.baseBuilder)().build(base), {
            sources: sources.length ? sources : undefined
        });
    }
    async getProjectWithInfo(context, param) {
        var _param_qsInclude;
        const base = await this.basesService.getProjectWithInfo(context, param);
        if (!base) _catchError.NcError.notFound('Base not found');
        // filter non-meta sources
        const sources = base.sources.filter((s)=>!new _models.Source(s).isMeta());
        return _extends({}, (0, _base.baseBuilder)().build(base), {
            sources: (sources == null ? void 0 : sources.length) ? (0, _base.sourceBuilder)().build(sources) : undefined
        }, ((_param_qsInclude = param.qsInclude) == null ? void 0 : _param_qsInclude.includes('members')) ? await this.baseMemberHelpers.getBaseMember(context, {
            baseId: param.baseId,
            isPrivateBase: base.default_role === 'no-access'
        }) : {});
    }
    async baseUpdate(context, param) {
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/BaseUpdate', param.base, true, {
            api_version: _nocodbsdk.NcApiVersion.V3
        });
        const meta = param.base.meta;
        if (meta == null ? void 0 : meta.icon_color) {
            meta.iconColor = meta.icon_color;
            delete meta.icon_color;
        }
        if (meta) {
            const metaParsed = _basemetaprops.BaseMetaProps.safeParse(meta);
            if (metaParsed.error) {
                _catchError.NcError.get({
                    api_version: _nocodbsdk.NcApiVersion.V3
                }).zodError({
                    message: `'meta' property invalid`,
                    errors: metaParsed.error
                });
            }
        }
        await this.basesService.baseUpdate(context, _extends({}, param, {
            base: _extends({}, param.base, await this.parseBaseRequest(context, param.base)),
            apiVersion: _nocodbsdk.NcApiVersion.V3
        }));
        return this.getProjectWithInfo(context, {
            baseId: param.baseId
        });
    }
    async baseCreate(param) {
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/BaseCreate', param.base, true, {
            api_version: _nocodbsdk.NcApiVersion.V3
        });
        const base = _extends({}, param.base, {
            fk_workspace_id: param.workspaceId,
            type: 'database'
        }, await this.parseBaseRequest({
            workspace_id: param.workspaceId
        }, param.base));
        const meta = param.base.meta;
        if (meta == null ? void 0 : meta.icon_color) {
            meta.iconColor = meta.icon_color;
            delete meta.icon_color;
        }
        if (meta) {
            const metaParsed = _basemetaprops.BaseMetaProps.safeParse(meta);
            if (metaParsed.error) {
                _catchError.NcError.get({
                    api_version: _nocodbsdk.NcApiVersion.V3
                }).zodError({
                    message: `'meta' property invalid`,
                    errors: metaParsed.error
                });
            }
        }
        const res = await this.basesService.baseCreate(_extends({}, param, {
            base,
            apiVersion: _nocodbsdk.NcApiVersion.V3
        }));
        return this.getProjectWithInfo({
            workspace_id: res.fk_workspace_id,
            base_id: _globals.RootScopes.WORKSPACE
        }, {
            baseId: res.id
        });
    }
    async baseSoftDelete(context, param) {
        await this.basesService.baseSoftDelete(context, param);
        return {};
    }
    async parseBaseRequest(_context, _base) {
        return {};
    }
    constructor(basesService){
        this.basesService = basesService;
        this.baseMemberHelpers = new _basememberhelpers.BaseMemberHelpers();
    }
};
BasesV3Service = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _basesservice.BasesService === "undefined" ? Object : _basesservice.BasesService
    ])
], BasesV3Service);
